
export const sidebarUser = {
  'backoffice.sidebarUser.sections.dashboard.title': 'Panel de Control',
  'backoffice.sidebarUser.sections.dashboard.items.summary': 'Resumen',
  'backoffice.sidebarUser.sections.myCommunity.title': 'Mi Comunidad',
  'backoffice.sidebarUser.sections.myCommunity.items.genealogyTree': 'Árbol Genealógico',
  'backoffice.sidebarUser.sections.myCommunity.items.communityMembers': 'Miembros de la Comunidad',
  'backoffice.sidebarUser.sections.investmentAccounts.title': 'Cuentas de Inversión',
  'backoffice.sidebarUser.sections.investmentAccounts.items.myAccounts': 'Mis Cuentas',
  'backoffice.sidebarUser.sections.investmentAccounts.items.addAccount': 'Agregar Cuenta',
  'backoffice.sidebarUser.sections.myProfits.title': 'Mis Ganancias',
  'backoffice.sidebarUser.sections.myProfits.items.accountsProfitSummary': 'Resumen de Ganancias de Cuentas',
  'backoffice.sidebarUser.sections.myProfits.items.accountsProfitHistory': 'Historial de Ganancias de Cuentas',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsSummary': 'Resumen de Comisiones',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsHistory': 'Historial de Comisiones',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsPaymentHistory': 'Historial de Pagos de Comisiones',
  'backoffice.sidebarUser.sections.myProfits.items.myPaymentMethods': 'Mis Métodos de Pago',
  'backoffice.sidebarUser.sections.startInvesting.title': 'Comenzar a Invertir',
  'backoffice.sidebarUser.sections.startInvesting.items.createRadexAccount': 'Crear Cuenta en Radex Markets',
  'backoffice.sidebarUser.sections.startInvesting.items.joinPammInstitutional': 'Unirse al PAMM Institutional Trading',
  'backoffice.sidebarUser.sections.startInvesting.items.joinPammSpartanAi': 'Unirse al PAMM Spartan AI',
  'backoffice.sidebarUser.sections.startInvesting.items.accessPammAccount': 'Acceder a tu Cuenta PAMM',
  'backoffice.sidebarUser.sections.tutorials.title': 'Tutoriales',
  'backoffice.sidebarUser.sections.myProfile.title': 'Mi Perfil',
  'backoffice.sidebarUser.sections.myProfile.items.theClubUserProfile': 'Perfil de Usuario de The Club',
  'backoffice.sidebarUser.sections.myProfile.items.personalInformation': 'Mi Información Personal',
  'backoffice.sidebarUser.sections.myProfile.items.paymentMethods': 'Mis Métodos de Pago',
  'backoffice.sidebarUser.sections.myProfile.items.referralLink': 'Mi Enlace de Referido',
  'backoffice.sidebarUser.sections.support.title': 'Soporte',
  'backoffice.sidebarUser.sections.support.items.helpCenter': 'Centro de Ayuda',
  'backoffice.sidebarUser.signOut': 'Cerrar Sesión'
};
